module.exports = __webpack_public_path__ + "static/media/logo_clothes.80355e38.png";